import React from "react";
import { Link } from "react-router-dom";

export const LOGO_URL = "/cherishlink-logo-narrow.png";

export function Logo({ to = "/", className = "", size = "md", dark = false }) {
  const sizes = {
    sm: "h-12",
    md: "h-16",
    lg: "h-24",
    xl: "h-32",
  };

  const image = (
    <img
      src={LOGO_URL}
      alt="CherishLink"
      className={`${sizes[size] || sizes.md} w-auto object-contain select-none`}
      style={dark ? { filter: "brightness(0) invert(1)" } : undefined}
      draggable={false}
      loading="eager"
      decoding="async"
      fetchPriority="high"
    />
  );

  if (!to) {
    return <span className={`inline-flex items-center ${className}`} data-testid="cherishlink-logo">{image}</span>;
  }

  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid="cherishlink-logo">
      {image}
    </Link>
  );
}

export default Logo;
